import CustomElement from '../core/custom.js';

export default window.customElements.define('video-autoplay', class extends CustomElement {
    constructor() {
        super();

        this._onVideoPlay = this.onVideoPlay.bind(this)
        this._onVideoPause = this.onVideoPause.bind(this)
    }

    connectedCallback() {
        super.connectedCallback()

        this.$video = this.querySelector('.js-video')

        if (!this.$video) {
            console.warn('VideoAutoplay: No video element defined (.js-video).', this)
            return
        }

        this.$video.addEventListener('playing', this._onVideoPlay, false)
        this.$video.addEventListener('pause', this._onVideoPause, false)

        this.observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    this.$video.play()
                } else {
                    this.$video.pause()
                }
            })
        })

        this.observer.observe(this.$video)
    }

    disconnectedCallback() {
        super.disconnectedCallback();

        if (!this.$video) { return }

        this.$video.removeEventListener('playing', this._onVideoPlay)
        this.$video.removeEventListener('pause', this._onVideoPause)

        this.observer.unobserve(this.$video)
        this.observer.disconnect()
    }

    onVideoPlay() {
		this._state = 'play'

		this.classList.add('is-played')
    }

    onVideoPause() {
        this._state = 'pause'

		this.classList.remove('is-played')
    }
});